import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type CostMappingOption from '@linc-technologies/linced-common/models/events/cost-mapping-option';

// Proto: events.CostMapping.
export default class CostMapping extends Fragment {
  declare [Type]: 'events/cost-mapping';

  @attr('string', { defaultValue: '' })
  declare optionId: string;

  @fragmentArray('events/cost-mapping-option')
  declare costMappingOptions: FragmentArray<CostMappingOption>;
}
